module.exports = __webpack_public_path__ + "img/icon-pay-success.5b9e6884.png";